const asset = require('./asset');
const blockTransformer = require('./block');
const makeTransformer = require('./make');
const modelPageTransformer = require('./modelPage');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');
const slug = require('slug');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: (entry.fields.name ? entry.fields.name['nb-NO'] : ''),
      intro: (entry.fields.intro ? entry.fields.intro['nb-NO'] : ''),
      introColor: (entry.fields.introColor ? entry.fields.introColor['nb-NO'] : ''),
      disableTestdrive: (entry.fields.disableTestdrive ? entry.fields.disableTestdrive['nb-NO'] : false),
      hiddenModel: (entry.fields.hiddenModel ? entry.fields.hiddenModel['nb-NO'] : false),
      hidePrice: (entry.fields.hidePrice ? entry.fields.hidePrice['nb-NO'] : false),
      disableConfigurator: (entry.fields.disableConfigurator ? entry.fields.disableConfigurator['nb-NO'] : false),
      disableDigitalCarView: (entry.fields.disableDigitalCarView ? entry.fields.disableDigitalCarView['nb-NO'] : false),
      modelGroup: (entry.fields.modelGroup ? entry.fields.modelGroup['nb-NO'] : ''),
      make: null,
      price: (entry.fields.price ? entry.fields.price['nb-NO'] : ''),
      vehicleClass: (entry.fields.vehicleClass ? entry.fields.vehicleClass['nb-NO'] : ''),
      shortDescription: (entry.fields.shortDescription ? entry.fields.shortDescription['nb-NO'] : ''),
      description: [],
      category: [],
      configurationId: (entry.fields.configurationId ? entry.fields.configurationId['nb-NO'] : ''),
      equipmentFactoryOrderList: (entry.fields.equipmentFactoryOrderList ? entry.fields.equipmentFactoryOrderList['nb-NO'] : null),

      url: (entry.fields.url && entry.fields.url['nb-NO'] ? entry.fields.url['nb-NO'] : ''),

      // Images
      image: null,
      displayname: '',
      listImage: null,
      silhouetteImage: null,
      modelLogo: null,
      imageGalleryExterior: [],
      imageGalleryInterior: [],
      imageGalleryColor: [],
      brochureImage: null,
      mobileImage: null,

      // Files
      tyreLabeling: null,
      brochures: [],
      priceLists: [],
      equipmentLists: [],
      pages: [],

      custom: (entry.fields.custom ? entry.fields.custom['nb-NO'] : null)
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.category && entry.fields.category['nb-NO']) {
      result.category = entry.fields.category['nb-NO'];
    }

    // Make
    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }

    // Displayname
    if (entry.fields.displayname && entry.fields.displayname['nb-NO']) {
      result.displayname = entry.fields.displayname['nb-NO'];
    }

    // Handle images:
    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = asset.contentfulToInternal(entry.fields.image['nb-NO']);
    }

    if (entry.fields.listImage && entry.fields.listImage['nb-NO'] && isResolvedResource(entry.fields.listImage['nb-NO'])) {
      result.listImage = asset.contentfulToInternal(entry.fields.listImage['nb-NO']);
    }

    if (entry.fields.silhouetteImage && entry.fields.silhouetteImage['nb-NO'] && isResolvedResource(entry.fields.silhouetteImage['nb-NO'])) {
      result.silhouetteImage = asset.contentfulToInternal(entry.fields.silhouetteImage['nb-NO']);
    }

    if (entry.fields.modelLogo && entry.fields.modelLogo['nb-NO'] && isResolvedResource(entry.fields.modelLogo['nb-NO'])) {
      result.modelLogo = asset.contentfulToInternal(entry.fields.modelLogo['nb-NO']);
    }

    if (entry.fields.brochureImage && entry.fields.brochureImage['nb-NO'] && isResolvedResource(entry.fields.brochureImage['nb-NO'])) {
      result.brochureImage = asset.contentfulToInternal(entry.fields.brochureImage['nb-NO']);
    }

    if (entry.fields.mobileImage && entry.fields.mobileImage['nb-NO'] && isResolvedResource(entry.fields.mobileImage['nb-NO'])) {
      result.mobileImage = asset.contentfulToInternal(entry.fields.mobileImage['nb-NO']);
    }

    if (entry.fields.imagegallery && entry.fields.imagegallery['nb-NO'] && isResolvedCollection(entry.fields.imagegallery['nb-NO'])) {
      result.imageGalleryExterior = entry.fields.imagegallery['nb-NO'].map(asset.contentfulToInternal);
    }

    if (entry.fields.imagegalleryInterior && entry.fields.imagegalleryInterior['nb-NO'] && isResolvedCollection(entry.fields.imagegalleryInterior['nb-NO'])) {
      result.imageGalleryInterior = entry.fields.imagegalleryInterior['nb-NO'].map(asset.contentfulToInternal);
    }

    if (entry.fields.imagegalleryColors && entry.fields.imagegalleryColors['nb-NO'] && isResolvedCollection(entry.fields.imagegalleryColors['nb-NO'])) {
      result.imageGalleryColor = entry.fields.imagegalleryColors['nb-NO'].map(asset.contentfulToInternal);
    }

    // handle files
    if (entry.fields.brochures && entry.fields.brochures['nb-NO'] && isResolvedCollection(entry.fields.brochures['nb-NO'])) {
      result.brochures = entry.fields.brochures['nb-NO'].map(
        asset.contentfulToInternal
      );
    }

    if (entry.fields.tyreLabeling && entry.fields.tyreLabeling['nb-NO'] && isResolvedResource(entry.fields.tyreLabeling['nb-NO'])) {
      result.tyreLabeling = asset.contentfulToInternal(entry.fields.tyreLabeling['nb-NO']);
    }

    if (entry.fields.priceLists && entry.fields.priceLists['nb-NO'] && isResolvedCollection(entry.fields.priceLists['nb-NO'])) {
      result.priceLists = entry.fields.priceLists['nb-NO'].map(
        asset.contentfulToInternal
      );
    }

    if (entry.fields.equipmentLists && entry.fields.equipmentLists['nb-NO'] && isResolvedCollection(entry.fields.equipmentLists['nb-NO'])) {
      result.equipmentLists = entry.fields.equipmentLists['nb-NO'].map(
        asset.contentfulToInternal
      );
    }

    if (entry.fields.pages && entry.fields.pages['nb-NO'] && isResolvedCollection(entry.fields.pages['nb-NO'])) {
      result.pages = entry.fields.pages['nb-NO'].map(
        modelPageTransformer.contentfulToInternal
      );
    }

    // Handle "description" content blocks:
    if (entry.fields.description && entry.fields.description['nb-NO'] && isResolvedCollection(entry.fields.description['nb-NO'])) {
      result.description = entry.fields.description['nb-NO'].map(blockTransformer.contentfulToInternal);
    }


    // Update model status based on content blocks status
    result.description.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(model) {
    const result = {
      fields: {
        displayname: {
          'nb-NO': model.displayname
        },
        intro: {
          'nb-NO': model.intro
        },
        introColor: {
          'nb-NO': model.introColor
        },
        configurationId: {
          'nb-NO': model.configurationId
        },
        description: [],
        shortDescription: {
          'nb-NO': model.shortDescription
        },
        disableTestdrive: {
          'nb-NO': (model.disableTestdrive === 'true' || model.disableTestdrive === true)
        },
        hiddenModel: {
          'nb-NO': (model.hiddenModel === 'true' || model.hiddenModel === true)
        },
        hidePrice: {
          'nb-NO': (model.hidePrice === 'true' || model.hidePrice === true)
        },
        disableConfigurator: {
          'nb-NO': (model.disableConfigurator === 'true' || model.disableConfigurator === true)
        },
        disableDigitalCarView: {
          'nb-NO': (model.disableDigitalCarView === 'true' || model.disableDigitalCarView === true)
        },
        equipmentFactoryOrderList: null,
        image: null,
        listImage: null,
        silhouetteImage: null,
        modelLogo: null,
        tyreLabeling: null,
        brochureImage: null,
        mobileImage: null,
        url: {
          'nb-NO': slug(model.url)
        }
      }
    };

    if (model.description) {
      result.fields.description = {
        'nb-NO': model.description.map(createEntryLink)
      };
    }

    if (model.equipmentFactoryOrderList) {
      result.fields.equipmentFactoryOrderList = {
        'nb-NO': model.equipmentFactoryOrderList
      };
    }

    if (model.pages) {
      result.fields.pages = {
        'nb-NO': model.pages.map(createEntryLink)
      };
    }

    // Categories
    let categories = [];
    if (model.category.length > 0) {
      categories = model.category;
    }
    result.fields.category = {
      'nb-NO': categories
    };

    // Images:
    if (model.image) {
      result.fields.image = {
        'nb-NO': createAssetLink(model.image)
      };
    }

    if (model.silhouetteImage) {
      result.fields.silhouetteImage = {
        'nb-NO': createAssetLink(model.silhouetteImage)
      };
    }

    if (model.listImage) {
      result.fields.listImage = {
        'nb-NO': createAssetLink(model.listImage)
      };
    }

    if (model.modelLogo) {
      result.fields.modelLogo = {
        'nb-NO': createAssetLink(model.modelLogo)
      };
    }

    if (model.brochureImage) {
      result.fields.brochureImage = {
        'nb-NO': createAssetLink(model.brochureImage)
      };
    }

    if (model.mobileImage) {
      result.fields.mobileImage = {
        'nb-NO': createAssetLink(model.mobileImage)
      };
    }

    // Image galleries
    if (model.imageGalleryExterior) {
      result.fields.imagegallery = {
        'nb-NO': model.imageGalleryExterior.map(createAssetLink)
      };
    }

    if (model.imageGalleryInterior) {
      result.fields.imagegalleryInterior = {
        'nb-NO': model.imageGalleryInterior.map(createAssetLink)
      };
    }

    if (model.imageGalleryColor) {
      result.fields.imagegalleryColors = {
        'nb-NO': model.imageGalleryColor.map(createAssetLink)
      };
    }

    // Files
    if (model.brochures) {
      result.fields.brochures = {
        'nb-NO': model.brochures.map(createAssetLink)
      };
    }

    if (model.priceLists) {
      result.fields.priceLists = {
        'nb-NO': model.priceLists.map(createAssetLink)
      };
    }

    if (model.tyreLabeling) {
      result.fields.tyreLabeling = {
        'nb-NO': createAssetLink(model.tyreLabeling)
      };
    }

    if (model.equipmentLists) {
      result.fields.equipmentLists = {
        'nb-NO': model.equipmentLists.map(createAssetLink)
      };
    }

    if (model.custom) {
      result.fields.name = {
        'nb-NO': model.name
      };

      if (model.makeId) {
        result.fields.make = {
          'nb-NO': createEntryLink({id: model.makeId})
        };
      }

      result.fields.custom = {
        'nb-NO': true
      };
    }

    return result;
  }
};
